import React from "react";

const Header = () => {
  return (
    <div className="header">
      <div className="header__container">
        <img className="header__logo" src="./logo.svg" alt="" />
      </div>
    </div>
  );
};

export default Header;
